<template>
<a-table class="stripped table-hover" :columns="columns" :data-source="data" :pagination="false" :row-selection="rowSelection"
  @change="handleTableSortChange">
  <template #bodyCell="{ column, record }">
    <template v-if="column.key === 'Name'">
      <h2 class="table-avatar d-flex align-items-center">
        <router-link :to="{ path: '/users/create-user', query: {userId: record.key}}" class="profile-split d-flex flex-column">{{ record.name }}</router-link>
      </h2>
    </template>
    <template v-else-if="column.key === 'Mobile'">
      <div>{{ record.phone_number }}</div>
    </template>
    <template v-else-if="column.key === 'IsActive'">
      <div>{{ record.is_active ? 'Yes' : 'No' }}</div>
    </template>
    <template v-else-if="column.key === 'action'">
          <router-link :to="{ path: '/users/create-user', query: {userId: record.key}}" class="btn table_action_btn"><i class="ti ti-edit"></i> Edit</router-link>
          <button
            type="button"
            class="btn table_action_btn ms-2"
            :class="{ 'text-gray': !record.is_active }"
            :disabled="!record.is_active"
            @click="confirmDeactivate(record.key)"
          >
            <i class="ti ti-user-off" :class="record.is_active ? 'text-warning' : 'text-gray'"></i> Deactivate
          </button>
          <a class="btn table_action_btn ms-2" href="javascript:;" @click="confirmDelete(record.key)">
            <i class="ti ti-trash text-danger"></i> Delete
          </a>
    </template>
  </template>
</a-table>

  <!-- Fixed Pagination -->
  <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      showSizeChanger :pageSizeOptions="pageSizeOptions" @change="handleTableChange" class="d-flex" />
  </div>

<div class="modal-backdrop fade show" v-if="showDeactivateModal"></div>
<div v-if="showDeactivateModal" class="modal custom-modal fade show" style="display: block;" tabindex="-1" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 m-0 justify-content-end">
        <button class="btn-close" @click="showDeactivateModal = false" aria-label="Close">
          <i class="ti ti-x"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="success-message text-center">
          <div class="success-popup-icon">
            <i class="ti ti-user-off text-warning"></i>
          </div>
          <h3>Deactivate User</h3>
          <p class="del-info">Are you sure you want to deactivate this user?</p>
          <div class="col-lg-12 text-center modal-btn">
            <button class="btn btn-light" @click="showDeactivateModal = false">Cancel</button>
            <button class="btn btn-warning" @click="deactivateUser(selectedUserId)">Yes, Deactivate</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop fade show" v-if="showDeleteModal"></div>
<div v-if="showDeleteModal" class="modal custom-modal fade show" style="display: block;" tabindex="-1" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 m-0 justify-content-end">
        <button class="btn-close" @click="showDeleteModal = false" aria-label="Close">
          <i class="ti ti-x"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="success-message text-center">
          <div class="success-popup-icon">
            <i class="ti ti-trash-x"></i>
          </div>
          <h3>Delete Account</h3>
          <p class="del-info">Are you sure you want to delete?</p>
          <div class="col-lg-12 text-center modal-btn">
            <button class="btn btn-light" @click="showDeleteModal = false">Cancel</button>
            <button class="btn btn-danger" @click="deleteUser(selectedUserId)">Yes, Delete it</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  ref,
  reactive,
  onMounted,
  computed
} from 'vue';
import {
  useRouter
} from 'vue-router';
import apiClient from "@/axios";
import {
    useStore
} from "vuex";
import {
  message
} from "ant-design-vue";

const isUserActive = (value) => value === true || value === 1 || value === '1';

export default {
  props: {
    searchUserQuery: String,
    isActiveFilter: String,
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();

    const sortFieldMap = {
      Name: 'first_name',
      role: 'role',
      Email: 'email',
      Territory: 'territory_name',
      Mobile: 'phone_number',
      Created: 'created',
    };

    const columns = [{
        title: "Name",
        dataIndex: "name",
        key: "Name",
        sorter: true,
      },
      {
        title: "Access Level",
        dataIndex: "role",
        key: "role",
        sorter: true,
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "Email",
        sorter: true,
      },
      {
        title: "Territory",
        dataIndex: "territory",
        key: "Territory",
        sorter: true,
      },
      {
        title: "Mobile",
        dataIndex: "phone_number",
        key: "Mobile",
        sorter: true,
      },
      {
        title: "Created",
        dataIndex: "created",
        key: "Created",
        sorter: true,
      },
      {
        title: "Is Active",
        dataIndex: "is_active",
        key: "IsActive",
        sorter: false,
      },
      {
        title: "Action",
        dataIndex: "Action",
        key: "action",
        sorter: false,
      },
    ];

    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const data = ref([]);
    const sorter = ref({ key: '', order: '', field: '' });
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0
    });
    const rowSelection = reactive({
      onChange: () => {},
      onSelect: () => {},
      onSelectAll: () => {},
    });
    const showDeleteModal = ref(false);
    const showDeactivateModal = ref(false);
    const selectedUserId = ref(null);

    // Methods
    const openEditModal = (id) => {
      router.push({
        path: "/users/create-user",
        query: {
          userId: id
        }
      });
    };

    const fetchUsers = async (page = 1, pageSize = 10, isActiveFilterValue) => {
      try {
        if (typeof page === 'number' && Number.isFinite(page)) {
          pagination.value.current = page;
        }
        const activeFilter = isActiveFilterValue !== undefined ? isActiveFilterValue : props.isActiveFilter;
        const params = {
          search: props.searchUserQuery,
          page: pagination.value.current,
          pageSize: pagination.value.pageSize,
          allUsers: 0,
          sort_field: sorter.value.field || undefined,
          sort_order: sorter.value.order || undefined,
        };
        if (activeFilter) {
          params.is_active = activeFilter;
        }
        const response = await store.dispatch('users/fetchUsers', params);
        if (response.status) {
          data.value = response.data.data.map((user) => ({
            key: user.id,
            name: user.last_name ? `${user.first_name} ${user.last_name}` : user.first_name,
            role: user.role,
            phone_number: formatPhoneNumber(user.phone_number),
            login_name: user.login_name,
            territory: user.territory_name,
            email: user.email,
            created: user.created ? formatDate(user.created) : null,
            is_active: isUserActive(user.is_active),
          }));
          pagination.value.total = response.data.total;
        } else {
          console.error("Failed to fetch users:", response);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    const formatPhoneNumber = (number) => {
      if (!number) {
        return ''; // Return an empty string if the input is empty or undefined
      }

      const cleaned = number.replace(/\D/g, '');

      // Check if the cleaned number is valid (e.g., 10 digits)
      if (cleaned.length === 10) {
        return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
      } else {
        // Optionally, return a placeholder or the original input if not valid
        return number; // Or return a default placeholder like 'Invalid number'
      }
    };

    const deleteUser = async (id) => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          message.error("No token found. Please log in again.");
          return;
        }
        const response = await apiClient.delete(`company/users/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
        });
        if (response.status) {
          message.success("User deleted successfully!");
          showDeleteModal.value = false;
          fetchUsers(pagination.value.current, pagination.value.pageSize);
        } else {
          message.error("Failed to delete User.");
        }
      } catch (error) {
        console.error("Error deleting User:", error);
        message.error("Error deleting User.");
      }
    };
 // Function to convert date format
    const formatDate = (dateTime) => {
      if(dateTime){
        return dateTime.replace(/-/g, '/');
      }
    };
    const confirmDelete = (id) => {
      selectedUserId.value = id;
      showDeleteModal.value = true;
    };

    const confirmDeactivate = (id) => {
      selectedUserId.value = id;
      showDeactivateModal.value = true;
    };

    const deactivateUser = async (id) => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          message.error("No token found. Please log in again.");
          return;
        }
        const response = await apiClient.get(`company/user/deactivate/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
        });
        if (response.status) {
          message.success("User deactivated successfully!");
          showDeactivateModal.value = false;
          fetchUsers(pagination.value.current, pagination.value.pageSize);
        } else {
          message.error("Failed to deactivate user.");
        }
      } catch (error) {
        console.error("Error deactivating user:", error);
        message.error(error.response?.data?.message || "Error deactivating user.");
      }
    };

    const handleTableChange = (current, pageSize) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      fetchUsers(pagination.value.current, pagination.value.pageSize);
    };

    const handleTableSortChange = (pag, filters, sort) => {
      if (sort?.order) {
        sorter.value.key = sort.columnKey;
        sorter.value.order = sort.order === 'ascend' ? 'ASC' : sort.order === 'descend' ? 'DESC' : '';
        sorter.value.field = sortFieldMap[sort.columnKey] ?? sort.columnKey;
      } else {
        sorter.value.key = '';
        sorter.value.order = '';
        sorter.value.field = '';
      }
      fetchUsers(pagination.value.current, pagination.value.pageSize);
    };

    // Lifecycle hook
    onMounted(() => {
      fetchUsers();
    });

    return {
      columns,
      data,
      pagination,
      formatDate,
      rowSelection,
      showDeleteModal,
      showDeactivateModal,
      selectedUserId,
      openEditModal,
      fetchUsers,
      formatPhoneNumber,
      deleteUser,
      deactivateUser,
      confirmDelete,
      confirmDeactivate,
      handleTableChange,
      handleTableSortChange,
      pageSizeOptions
    };
  },
};
</script>
